const TOKEN = "atoken";
const saveToken = (token) => {
  localStorage.setItem(TOKEN, token);
};
const getToken = () => {
  return localStorage.getItem(TOKEN);
};
const deleteToken = () => {
  localStorage.removeItem(TOKEN);
};
const isLoggedIn = () => {
  return localStorage.getItem(TOKEN) !== null;
};
const saveName = (name) => {
  localStorage.setItem("name", name);
};
const getName = () => {
  return localStorage.getItem("name");
};
const shuffleFisherYates = (array) => {
  let i = array.length;
  while (i--) {
    const ri = (Math.floor(Math.random() * i)[(array[i], array[ri])] = [
      array[ri],
      array[i],
    ]);
  }
  return array;
};
// Tags and attributes a question or option may legitimately contain.
const ALLOWED_TAGS = new Set([
  "B","STRONG","I","EM","U","S","STRIKE","SUB","SUP","BR","P","DIV","SPAN",
  "UL","OL","LI","TABLE","THEAD","TBODY","TFOOT","TR","TD","TH","CAPTION",
  "PRE","CODE","BLOCKQUOTE","H1","H2","H3","H4","H5","H6","IMG","A","HR","FONT",
]);
const ALLOWED_ATTRS = new Set([
  "src","alt","title","width","height","align","colspan","rowspan","class","style","href","target","rel","color","face",
]);
const DROP_ENTIRELY = new Set([
  "SCRIPT","IFRAME","OBJECT","EMBED","LINK","META","STYLE","SVG","MATH","FORM","INPUT","BUTTON","TEXTAREA","SELECT","BASE","AUDIO","VIDEO","SOURCE",
]);
const SAFE_URL = /^(https?:|data:image\/(png|jpe?g|gif|webp|bmp|svg\+xml);|mailto:|tel:|\/|\.\/|#)/i;

// Sanitise stored HTML before it is handed to html-react-parser.
//
// This was previously a no-op string cast, so trainer-authored question and
// option HTML rendered into the admin console untouched — a stored-XSS path
// from a trainer account straight into an admin session. Mirrors the same
// function in the Web app.
const cleanO = (str) => {
  if (str === null || str === undefined) return "";
  if (typeof str !== "string") str = str.toString();
  if (typeof document === "undefined") return str;

  const wrapper = document.createElement("div");
  wrapper.innerHTML = str;

  const sanitise = (parent) => {
    [...parent.childNodes].forEach((node) => {
      if (node.nodeType === 8) return node.remove();
      if (node.nodeType !== 1) return;
      if (DROP_ENTIRELY.has(node.tagName)) return node.remove();
      if (!ALLOWED_TAGS.has(node.tagName)) {
        sanitise(node);
        while (node.firstChild) parent.insertBefore(node.firstChild, node);
        return node.remove();
      }
      [...node.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        const value = attr.value || "";
        if (name.startsWith("on") || !ALLOWED_ATTRS.has(name)) {
          return node.removeAttribute(attr.name);
        }
        if ((name === "src" || name === "href") && !SAFE_URL.test(value.trim())) {
          return node.removeAttribute(attr.name);
        }
        if (name === "style" && /expression\(|javascript:|url\s*\(\s*['"]?\s*(?!data:image)/i.test(value)) {
          return node.removeAttribute(attr.name);
        }
      });
      if (node.tagName === "A") node.setAttribute("rel", "noopener noreferrer nofollow");
      sanitise(node);
    });
  };
  sanitise(wrapper);
  return wrapper.innerHTML;
};
const activeArranger = (tcs) => {
  tcs.sort((a, b) => {
    let fa = a.category.toLowerCase(),
      fb = b.category.toLowerCase();
    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  });
  let actives = tcs.filter((t) => t.status === "Active");
  let inactives = tcs.filter((t) => t.status === "Inactive");
  let ars = actives.concat(inactives);
  return ars;
};
const activeTopicArranger = (tcs) => {
  tcs.sort((a, b) => {
    let fa = a.topic.toLowerCase(),
      fb = b.topic.toLowerCase();
    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  });
  let actives = tcs.filter((t) => t.status === "Active");
  let inactives = tcs.filter((t) => t.status === "Inactive");
  let ars = actives.concat(inactives);
  return ars;
};
const isReallyNumber = (data) => {
  let regex = /^[0-9]+$/;
  return !!data.match(regex);
};
const makeUnique = (array = [], keys = []) => {
  if (!keys.length || !array.length) return [];

  return array.reduce((list, item) => {
    const hasItem = list.find((listItem) =>
      keys.every((key) => listItem[key] === item[key])
    );
    if (!hasItem) list.push(item);
    return list;
  }, []);
};
const getHeader = () => {
  return {
    headers: {
      "content-type": "application/json",
      token: getToken(),
    },
  };
};
const getDateFormat = (d) => {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let y = d.getFullYear();
  let dd = "0" + d.getDate();
  let h = "0" + d.getHours();
  let min = "0" + d.getMinutes();
  return (
    dd.slice(-2) +
    " " +
    months[d.getMonth()] +
    " " +
    y +
    ", " +
    h.slice(-2) +
    ":" +
    min.slice(-2)
  );
};

const getDifferenceInDays = (date1, date2) => {
  // Convert to Date objects if they are strings
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Calculate the time difference in milliseconds
  const timeDifference = Math.abs(d2 - d1);

  // Convert to days
  return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
};

export {
  getDateFormat,
  saveToken,
  shuffleFisherYates,
  getToken,
  saveName,
  getHeader,
  getName,
  isLoggedIn,
  deleteToken,
  cleanO,
  activeArranger,
  activeTopicArranger,
  makeUnique,
  isReallyNumber,
  getDifferenceInDays,
};
